<shared-badge
  [class]="'badge badge-pill badge-success-light'"
  [label]="label"
  [tooltip]="tooltip"
>
</shared-badge>
